import { FhirBundleSdk } from "@metriport/fhir-sdk";
import { getFamilyMemberHistoryRows } from "./family-history-rows";

export const metadata = {
  tableType: "FamilyMemberHistory",
  displayName: "Family Member History",
  getRows: (bundle: FhirBundleSdk) => getFamilyMemberHistoryRows({ bundle }),
};
